import { schedulerSetup } from "../schedulerSetup";

export const guarantorInformationState = schedulerSetup.createStateConfig({
  meta: {
    componentKey: "guarantor-information",
    label: "guarantorInformation",
    showFooter: true,
    getSubtitle: (ctx) =>
      ctx.guarantorData.firstName
        ? `${ctx.guarantorData.firstName} ${ctx.guarantorData.lastName}`
        : undefined,
  },
  initial: "idle",
  states: {
    idle: {
      on: {
        SUBMIT_GUARANTOR_DATA: [
          {
            guard: "hasValidGuarantorData",
            target: "complete",
            actions: [
              { type: "clearErrors" },
              {
                type: "assignGuarantorData",
                params: ({ event }) => ({ data: event.data }),
              },
              { type: "markStepComplete", params: { step: "guarantorInformation" } },
            ],
          },
          {
            actions: {
              type: "assignGuarantorErrors",
              params: ({ event }) => ({
                data: event.data,
                language: event.language,
              }),
            },
          },
        ],
      },
    },
    complete: { type: "final" },
  },
  on: {
    // Back to the step before: patient details on slot-first flows, the slot otherwise.
    BACK: [
      { guard: "isSlotFirstFlow", target: "patientInformation" },
      { target: "dateTimeSelection" },
    ],
  },
  onDone: "appointmentReview",
} as const);
